import { useFormikContext } from 'formik';
import { useBenhAnContext } from 'src/app/modules/phan-he-noi-tru-dieu-tri/components/benh-an/context/BenhAnContext';
import { usePhanHeDieuTriNoiTruContext } from 'src/app/modules/phan-he-noi-tru-dieu-tri/PhanHeDieuTriContext';
import { parseJSON } from 'src/app/modules/utils/FormatUtils';
import TreatmentTemplateButton from '../../../../../../treatment-template-button/TreatmentTemplateButton';
import { onConvertData } from "../common";

const PhieuDieuTriAction = () => {
	const { values, setValues } = useFormikContext<any>();
	const { phieuBenhAn } = useBenhAnContext();
	const { benhNhanDieuTri } = usePhanHeDieuTriNoiTruContext();

	const getSaveParams = () => {
		const formValue = JSON.stringify(values);

		return {
			type: phieuBenhAn?.attributes?.templateType,
			template: formValue,
			patientId: benhNhanDieuTri?.patientId,
			visitId: benhNhanDieuTri?.visitId,
		};
	};

	const onSelectMauChiDinhMau = (data: any) => {
		const templateData = parseJSON(data);
		setValues(templateData);
	};

	return (
		<div className="d-flex justify-content-end gap-3 spaces pt-4">
			<TreatmentTemplateButton
				getSaveParams={getSaveParams}
				onSelectMau={onSelectMauChiDinhMau}
				onConvertData={onConvertData}
				searchParams={{
					type: phieuBenhAn?.attributes?.templateType,
				}}
			/>
		</div>
	);
};

export default PhieuDieuTriAction;
